"use client"

import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react"
import { X } from "lucide-react"
import { type ReactNode } from "react"

import { IconButton } from "../../control/IconButton"

export interface SidePanelShellProps {
  open: boolean
  onClose: () => void
  title?: string
  footer?: ReactNode
  children: ReactNode
}

// SidePanelShell is the presentational shell for a sliding panel — the SidePanel equivalent of ModalShell.
export function SidePanelShell({
  open,
  onClose,
  title,
  footer,
  children,
}: SidePanelShellProps) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-40">
      <DialogBackdrop
        transition
        className="bg-v2-background-scrim ease-panel data-closed:opacity-0 fixed inset-0 transition-opacity duration-300"
      />
      <div className="fixed inset-0 flex justify-end">
        <DialogPanel
          transition
          className="bg-v2-background-elevation-modal shadow-v2-modal ease-panel data-closed:translate-x-full rounded-l-overlay flex h-full w-full max-w-md flex-col overflow-hidden transition-transform duration-300"
        >
          <div className="border-v2-border-default flex shrink-0 items-center justify-between gap-4 border-b px-4 py-3">
            <DialogTitle className="color-default text-title-lg min-w-0 truncate">
              {title}
            </DialogTitle>
            <IconButton icon={X} onClick={onClose} aria-label="Close" />
          </div>
          <div className="flex-1 overflow-y-auto">{children}</div>
          {footer && (
            <div className="border-v2-border-default shrink-0 border-t p-4">
              {footer}
            </div>
          )}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
